module.exports = __webpack_public_path__ + "d5afba0d29849056ced97b4f4f16e432.jpg";